import { create as createStore } from 'zustand';

interface IStore {
  isPromoter: boolean;
  isDetractor: boolean;
  setIsPromoter: (vote: number) => void;
  setIsDetractor: (vote: number) => void;
}

export const useNpsIsPromoter = createStore<IStore>(set => ({
  isPromoter: false,
  isDetractor: false,
  setIsPromoter: (vote: number | undefined) => {
    if (!!vote && vote >= 9) {
      set({ isPromoter: true });
    } else {
      set({ isPromoter: false });
    }
  },
  setIsDetractor: (vote: number | undefined) => {
    if (!!vote && vote <= 6) {
      set({ isDetractor: true });
    } else {
      set({ isDetractor: false });
    }
  }
}));
